import React from 'react';
import { useStyletron } from 'baseui';
import { StyledTable, StyledHeadCell, StyledBodyCell } from 'baseui/table-grid';
import { Tag, KIND } from 'baseui/tag';
import { ISegmentInteraction } from '../../../utils/types';

interface SegmentsTabProps {
	interactions: ISegmentInteraction[];
}

const PATTERN_KIND: Record<string, string> = {
	override: KIND.warning,
	conditional: KIND.accent,
	additive: KIND.positive
};

const SegmentsTab: React.FC<SegmentsTabProps> = ({ interactions }) => {
	const [css] = useStyletron();

	if (!interactions?.length) {
		return (
			<div className={css({ padding: '24px', color: '#666' })}>
				No segment interactions found. This config key applies uniformly to all users.
			</div>
		);
	}

	return (
		<div className={css({ padding: '16px' })}>
			<StyledTable $gridTemplateColumns='1fr 1fr 1fr 2fr'>
				<StyledHeadCell>Segment Type</StyledHeadCell>
				<StyledHeadCell>Segment Key</StyledHeadCell>
				<StyledHeadCell>Pattern</StyledHeadCell>
				<StyledHeadCell>Behavior</StyledHeadCell>
				{interactions.map((interaction) => (
					<React.Fragment key={`${interaction.segmentType}-${interaction.segmentKey}`}>
						<StyledBodyCell>
							<Tag closeable={false} kind={KIND.primary}>
								{interaction.segmentType}
							</Tag>
						</StyledBodyCell>
						<StyledBodyCell>
							<code className={css({ fontSize: '13px' })}>{interaction.segmentKey}</code>
						</StyledBodyCell>
						<StyledBodyCell>
							<Tag closeable={false} kind={(PATTERN_KIND[interaction.interactionPattern] || KIND.primary) as any}>
								{interaction.interactionPattern}
							</Tag>
						</StyledBodyCell>
						<StyledBodyCell>{interaction.behaviorDescription}</StyledBodyCell>
					</React.Fragment>
				))}
			</StyledTable>
		</div>
	);
};

export default SegmentsTab;
